import { Card, CardContent, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ProfileTitle from "../../../components/backoffice-users-profile/title";
import UsersProfile from "../../../components/backoffice-users-profile/userProfile";
import UserSecurity from "../../../components/backoffice-users-profile/userSecurity";
import { selectCurrentUser } from "../../../store/slices/currentUser";

const Users = () => {
  const user = useSelector(selectCurrentUser);
  const location = useLocation();
  const state = location.state;

  return (
    <>
      <Grid
        container
        pt="0px"
        spacing={2}
        sx={{
          width: "100%",
          marginBottom: 3,
          marginTop: 0,
          paddingBottom: 10,
        }}
      >
        <Grid item xs={12} md={4}> 
          <Card elevation={3} sx={{ height: "100%", width: "100%", mb: 2 }}> 
            <CardContent>
              <ProfileTitle isOther={state?.otherUser || false} />
            </CardContent>
            <CardContent>
              <UsersProfile user={state || user} /> 
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={8}> 
          <Card elevation={3} sx={{ height: "100%", width: "100%" }}> 
            <CardContent>
               < UserSecurity userId={(state?.userId || user.userId)} userName={(state?.username || user.userName)} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default Users;
